import RenderersSetup from './renderers/PluginSetup';
import AttributesSetup from './attributes/PluginSetup';
export default {
  install(molten) {
    RenderersSetup.install(molten);
    AttributesSetup.install(molten);
  }
};